module.exports = __webpack_public_path__ + "media/images/menu/games-0eeb77f7d16c314d124c356604a12a26.jpg";